import { apiGet, GetConsulteesResponse } from 'api';

export const getConsultees = (): Promise<GetConsulteesResponse> =>
  apiGet<GetConsulteesResponse>('consultees');
